import { Helmet } from "react-helmet";
import { connect, useDispatch } from "react-redux";
import styles from "./style.module.scss";
import ContainerHeader from "views/components/ContainerHeader";
import HealthStatus from "views/components/HealthStatus";
import { useEffect } from "react";
import {
  fetchDataset,
  fetchFilterConfig,
  fetchSavedViews,
} from "redux/SingleDataset/actions";
import { useParams } from "react-router";
import SavedViewsTable from "./Table";
import {
  getSavedViews,
  getIsSavedViewsLoading,
} from "redux/SingleDataset/selectors";
import { State } from "redux/store";
import { SavedView } from "types";
import { NoViewsComponent } from "views/pages/SavedViewsPage/NoViewComponent";
import ContentLoad from "views/uikit/ContentLoad";
import ViewSharingMenu from "views/components/SharingMenu/ViewSharingMenu";

interface SavedViewsPageProps {
  savedViews: SavedView[];
  savedViewsLoading: boolean;
}

const SavedViewsPage = ({
  savedViews,
  savedViewsLoading,
}: SavedViewsPageProps) => {
  const { viewsDatasetId } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchDataset(viewsDatasetId) as any);
    dispatch(fetchFilterConfig(viewsDatasetId) as any);
    dispatch(fetchSavedViews(viewsDatasetId) as any);
    //eslint-disable-next-line
  }, [viewsDatasetId]);

  return (
    <>
      <Helmet>
        <title>Dataset Saved Views</title>
      </Helmet>
      <div className={styles.headerContainer}>
        <ContainerHeader />
        <HealthStatus />
      </div>
      {savedViewsLoading ? (
        [...Array(10)].map((_: any, index: number) => (
          <div className={styles.tableLoading} key={index}>
            <ContentLoad />
          </div>
        ))
      ) : (
        <div className={styles.tableContainer}>
          {savedViews.length > 0 ? (
            <SavedViewsTable />
          ) : (
            <div className={styles.noViewsContainer}>
              <NoViewsComponent />
            </div>
          )}
        </div>
      )}
      <ViewSharingMenu />
    </>
  );
};

const mapStateToProps = (state: State) => ({
  savedViews: getSavedViews(state),
  savedViewsLoading: getIsSavedViewsLoading(state),
});

export default connect(mapStateToProps)(SavedViewsPage);
